<lib-select-search
  [label]="'machinery.selection' | translate"
  [required]="required"
  [items]="(machineOptions | async) ?? []"
  [ngModel]="getPreselectedItem() | async"
  (selectedItemChanged)="onSelectionChanged($event)"
></lib-select-search>
